import { render } from "./TrainingProgramList.vue?vue&type=template&id=7417fffe&ts=true"
import script from "./TrainingProgramList.vue?vue&type=script&lang=ts"
export * from "./TrainingProgramList.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__